import { ReportPaginateResponseData } from '../utils/reportPaginate.util'
import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'

export interface LabelTraceCreateManyRequest {
  workOrder?: number
  lineNumber?: string
  scans?: string[]
  latitude?: number
  longitude?: number
}

interface LabelTraceData {
  id: number
  siteId: number
  workOrderId: number
  lineNumber: string
  createdBy: number
  scan: string
  latitude?: number
  longitude?: number
  createdAt: string
}

export interface LabelTraceReportExportRequest {
  startAt?: string
  endAt?: string
  item?: number
}

export interface LabelTraceReportPaginateRequest
  extends LabelTraceReportExportRequest, PaginateRequest {}

type LabelTraceReportPaginateResponse = PaginateResponse<ReportPaginateResponseData[]>

const routes = {
  createMany: '/labelTraces',
  paginateReport: '/labelTraces/report/paginate',
  exportReport: '/labelTraces/report/export'
}

export default {
  createMany (
    payload: LabelTraceCreateManyRequest,
    callback: ResponseCallback<LabelTraceData[]>
  ) {
    api.post(routes.createMany, payload, callback)
  },

  paginateReport (
    payload: LabelTraceReportPaginateRequest,
    callback: ResponseCallback<LabelTraceReportPaginateResponse>
  ) {
    api.post(routes.paginateReport, payload, callback)
  },

  exportReport (
    payload: LabelTraceReportExportRequest,
    callback: ResponseCallback<Blob>
  ) {
    api.post(routes.exportReport, payload, callback)
  }
}
